import { jsonldRecipeCategory } from './JsonldStore';

export const updateJsonldRecipeCategory = (value) => jsonldRecipeCategory.update((oldValue) => value);
